/**
 * The ReturnUrl as a path on this site, or undefined when it's missing or goes anywhere else. It comes from the
 * query string, so without this a link could send someone to another site, or run a javascript: url, as they sign in.
 */
export function toSameOriginPath(returnUrl: string | null | undefined) {
	if (!returnUrl?.trim()) return undefined;
	let url: URL;
	try {
		//Parsed the way the browser will navigate, so tricks like //host, /\host or tabs inside the url can't slip past
		url = new URL(returnUrl, window.location.origin);
	} catch {
		return undefined;
	}
	if (url.origin !== window.location.origin) return undefined;
	return url.pathname + url.search + url.hash;
}
